const expirationNoticePopupButton = document.getElementById(
  'js-expiration-notice-popup-button'
);

if (expirationNoticePopupButton) {
  expirationNoticePopupButton.addEventListener(
    'click',
    manageShopNoticeExpiration
  );
}

/**
 * Manage expiration notice clicks
 *
* @version     1.0.0
 * @since       2023.26
 */
async function manageShopNoticeExpiration(e) {
  const button = e.currentTarget;
  const popup = button.closest('.js-popup');
  const shopId = popup.getAttribute('data-shop-id');

  try {
    button.disabled = true;
    popup.remove();
    button.classList.add('is-loading');

    const response = await fetch(shops_object.admin_ajax_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: new URLSearchParams({
        action: 'expiration_notice_dismissal_request',
        expiration_notice_nonce: shops_object.expiration_notice_nonce,
        shop_id: shopId,
      }),
      credentials: 'same-origin',
    });
    const data = await response.json();
    if (!data.success) {
      const err = new Error(data.data.message);
      throw err;
    }
  } catch (error) {
    alert(error);
  }
}
